import { type GoalOverview, GoalOverviewSubType, GoalOverviewType } from "Infrastructure/ApiZfp/Schema";
import { type ResourcePathType, Resources } from "Infrastructure/Translations/Resources";

/** Maps the API goal type onto its key in `Resources.AnalysisDetail.Goals.GoalType`. */
export const GOAL_TYPE_MAP: Record<GoalOverviewType, "Pension" | "FinancialReserve" | "Housing" | "Vehicle" | "Children" | "Other"> = {
  [GoalOverviewType.pension]: "Pension",
  [GoalOverviewType.financial_reserve]: "FinancialReserve",
  [GoalOverviewType.housing]: "Housing",
  [GoalOverviewType.vehicle]: "Vehicle",
  [GoalOverviewType.children]: "Children",
  [GoalOverviewType.other]: "Other",
};

const TimelineGoalType = Resources.AnalysisDetail.Goals.Timeline.GoalType;

const HOUSING_SUB_TYPE_LABELS: Partial<Record<GoalOverviewSubType, ResourcePathType>> = {
  [GoalOverviewSubType.housing_property]: TimelineGoalType.HousingProperty,
  [GoalOverviewSubType.housing_mortgage]: TimelineGoalType.HousingMortgage,
  [GoalOverviewSubType.housing_other]: TimelineGoalType.HousingOther,
};

export const getTimelineGoalTypeLabel = ({ type, subType }: Pick<GoalOverview, "type" | "subType">) =>
  (type === GoalOverviewType.housing && HOUSING_SUB_TYPE_LABELS[subType]) || TimelineGoalType[GOAL_TYPE_MAP[type]];
